import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=63fa8dac&scoped=true&"
import script from "./imprint.vue?vue&type=script&lang=js&"
export * from "./imprint.vue?vue&type=script&lang=js&"
import style0 from "./imprint.vue?vue&type=style&index=0&id=63fa8dac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa8dac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
